import { useLocation } from 'react-router-dom';

import {
  normalizeOralArgumentsFiltersToApiParams,
  CourtSearchPage,
  useOralArgumentsSearch,
  useQueryParams,
} from '../shared';
import { type OralArgumentsResponse } from '../types';

import { OralArgumentsResults } from './OralArgumentsResults';
import {
  OralArgumentsSearchForm,
  type OralArgumentsSearchFormData,
  type OralArgumentsSearchType,
} from './OralArgumentsSearchForm';

const ORAL_ARGUMENTS_QUERY_PREFIX_MAP: Record<string, OralArgumentsSearchType> =
  {
    'docketNumber:': 'docketNumber',
    'caseName:': 'caseName',
    'judge:': 'judgeName',
  };

export const OralArgumentsSearch = () => {
  const { search } = useLocation();
  const queryParams = useQueryParams(search);
  const query = queryParams.get('query') || '';
  const exactMatchParam = queryParams.get('exact_match');
  const initialExactMatch = exactMatchParam !== 'false';

  const normalizeFilters = (filters: unknown) =>
    normalizeOralArgumentsFiltersToApiParams(
      filters as Parameters<typeof normalizeOralArgumentsFiltersToApiParams>[0]
    );

  return (
    <CourtSearchPage<
      OralArgumentsResponse,
      OralArgumentsSearchFormData,
      OralArgumentsSearchType
    >
      queryPrefixMap={ORAL_ARGUMENTS_QUERY_PREFIX_MAP}
      normalizeFilters={normalizeFilters}
      useSearchHook={useOralArgumentsSearch}
      initialQuery={query}
      initialExactMatch={initialExactMatch}
      SearchForm={OralArgumentsSearchForm}
      ResultsComponent={OralArgumentsResults}
    />
  );
};
